module.exports = __webpack_public_path__ + "static/image/logo-family/logo_ceo.png?85dae0f5";